import { useTeamsOptions } from '@/hooks/selectOptions/useTeamsOptions'
import Button from '../common/Button'
import Modal from '../common/Modal'
import SelectBoxAsynk from '../common/SelectBoxAsynk'
import { useState } from 'react'
import { ITeamManagmant } from '@/types/tenant/team.types'
import { useUpdateTeamMutation } from '@/services/tenant/teamManagement'
import { toast } from 'react-toastify'

interface IAddToTeamModalProps {
    isOpen: boolean
    onClose: () => void
    userId: string | number | null
}

const AddToTeam = ({ isOpen, onClose, userId }: IAddToTeamModalProps) => {
    const { loadOptionsTeams, teamsData } = useTeamsOptions()
    const [updateTeam] = useUpdateTeamMutation()
    const [selectedTeam, setSelectedTeam] = useState<number | null>(null)
    const handelClose = () => {
        onClose()
    }

    const onSubmit = async () => {
        if (!selectedTeam || !userId) return
        const usersData =
            teamsData?.data
                .find(
                    (team: ITeamManagmant) => +team.team?.id === +selectedTeam,
                )
                ?.team?.members?.map(member => member.id) || []

        const formData = {
            members: usersData?.includes(Number(userId))
                ? usersData
                : [...usersData, Number(userId)],
        }

        const res = await updateTeam({
            teamId: selectedTeam,
            body: formData,
        }).unwrap()

        if (res?.success) {
            handelClose()
        } else {
            toast.error(
                res?.errors?.[0]?.msg || res?.message || 'Something went wrong',
            )
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={handelClose}
            title={'Add to Team'}
        >
            <div className="modal__body p-0">
                <div className="custom-form">
                    <div className="custom-form-body">
                        <div className="row gutters-16">
                            <div className="col-12">
                                <SelectBoxAsynk
                                    wrapperClassName="input--lg select-secondary select-left-spase-0"
                                    fetchFunk={loadOptionsTeams}
                                    placeholder={'Select Team'}
                                    isClearable
                                    onChange={option => {
                                        setSelectedTeam(option?.value)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-footer justify-end">
                        <div className="flex-group flex-group--xs">
                            <Button
                                type="button"
                                onClick={onSubmit}
                                size="lg"
                                variant="primary-gradient"
                                disabled={!selectedTeam}
                            >
                                <span>Save Changes</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default AddToTeam
